export default __webpack_public_path__ + "static/media/card8.335cc497.svg";